module.exports = __webpack_public_path__ + "static/media/1f468-1f469-1f467.a0e7965b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f468-1f469-1f467.svg
// module id = 635
// module chunks = 1